import keycloak from "./keycloak"
import axios from "axios";
import { apiLoadingStore } from "./loadingStore";

const devPort = process.env.REACT_APP_DEV_BACKEND_PORT
const endpoint = process.env.REACT_APP_BACKEND_URL || `${window.location.protocol}//${window.location.hostname}${devPort ? `:${devPort}` : ''}/api`

export class BaseApiManager {
    constructor(pathExtension = '') {
        this.endpoint = endpoint + pathExtension
        this.customAxios = axios.create({ baseURL: this.endpoint })
        this.isRedirecting = false
        this.abortController = new AbortController()

        this.customAxios.interceptors.request.use(async (config) => {
            config.signal = this.abortController.signal
            if (keycloak?.authenticated) {
                try {
                    await keycloak.updateToken(5)
                } catch (e) {
                    // Allow flow through, will fail on backend with 401 and redirect to login
                    console.warn(`Encountered error refreshing token: ${e}`)
                }
                if (keycloak?.token) {
                    // attach token to request if token exists
                    config.headers = {
                        ...config.headers,
                        Authorization: `Bearer ${keycloak.token}`,
                    }
                }
            }

            if (config.showLoader === true) {
                apiLoadingStore.startRequest();
            }

            return config
        }, (error) => {
            apiLoadingStore.endRequest();
            return Promise.reject(error);
        })

        this.customAxios.interceptors.response.use(
            (res) => {
                const showLoader = res.config.showLoader === true;

                if (showLoader) {
                    apiLoadingStore.endRequest();
                }

                return res
            },
            async (err) => {
                const status = err?.response?.status
                if (status === 401) {
                    this.abortAllInFlight()
                    if (!this.isRedirecting) {
                        this.isRedirecting = true
                        try {
                            await keycloak.login({ redirectUri: window.location.href })
                        } finally {
                            this.isRedirecting = false
                        }
                    }
                    return Promise.reject()
                }

                const config = err.config;

                if (!config || config.showLoader === true) {
                    apiLoadingStore.endRequest();
                }

                return Promise.reject(err)
            }
        )
    }

    abortAllInFlight() {
        try { this.abortController.abort(); } catch {}
        this.abortController = new AbortController();
        apiLoadingStore.clearAll()
      }

    alertFailureMessage = (err) => {
        if (err?.response?.data?.msg) {
            console.error(err.response.status, err.response.data)
            alert(err.response.data.msg)
        } else {
            console.error(err)
            alert("Server error occurred. Please report findings.")
        }
    }

    hasValidAuthToken() {
        return !!keycloak.token
    }

    getAuthHeaders = () => {
        return {
            Authorization: `Bearer ${keycloak.token}`
        }
    }
}